import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import { formatCurrencyHasSymbol } from '../../../../../utils/commonFunctions'
import { formatDateBilling } from '../../billingOverview/component/CreditGrants/CreditGrants'
import CCModal2025 from '../../../../../components/ccModal2025'
import { scheduleCancelFleetBillingSubscriptionApi } from '../../../../../constants/ApiConfigs'
import { callApiWithoutDispatch } from '../../../../../utils/apiUtils'
import { BILLING_PLAN_TYPE } from '../../../../../features/signup/constantStep'
import { I18n } from 'react-redux-i18n'

const SummarySubscription = ({
	billingUsage = {},
	handleLoadBillingUsage,
	auth = {},
	context = {},
	permissions,
	...props
}) => {
	const [isShowModalConfirmCancelSubscription, setIsShowModalConfirmCancelSubscription] = useState(false)
	const findAddOnsActive = () => {
		return billingUsage?.addOnsSettings?.filter(addOn => {
			return billingUsage?.addOns?.some(item => item.id === addOn._id)
		})
	}

	const onCancelSubscription = async (isCancel) => {
		props.loadingActions.showLoadingSpiner()
		try {
			const response = await callApiWithoutDispatch(scheduleCancelFleetBillingSubscriptionApi, {
				method: 'POST',
				body: JSON.stringify({
					fleetId: auth?.selectedFleet?.fleetId,
					cancel: isCancel
				}),
			})
			if (response?.res?.data) {
				context.notification('success', 'Subscription cancelled successfully')
				handleLoadBillingUsage()
				setIsShowModalConfirmCancelSubscription(false)
			} else {
				context.notification('error', 'Failed to cancel subscription')
			}
		} catch (error) {
			context.notification('error', 'Failed to cancel subscription')
		} finally {
			props.loadingActions.hideLoadingSpiner()
		}
	}

	const rendModalConfirmCancelSubscription = () => {
		return (
			<>
				
				<CCModal2025
					isShow={isShowModalConfirmCancelSubscription}
					onClose={() => {
						setIsShowModalConfirmCancelSubscription(false)
					}}
					onSubmit={() => {
						onCancelSubscription(true)
					}}
					className="cancel-subscription-modal"
					title={I18n.t('billingUsage.cancelSubscription')}
					btnCloseText={I18n.t('billingUsage.no')}
					btnSubmitText={I18n.t('billingUsage.yes')}
					size="sm"
				>
					<p>{I18n.t('billingUsage.areYouSureCancelSubscription')} <span style={{ color: '#F04438' }}>{I18n.t('billingUsage.until')} {formatDateBilling(billingUsage?.currentPeriodEnd)}</span></p>
				</CCModal2025>
				
			</>
		)
	}

	const checkShowResumeSubscription = () => {
		return billingUsage?.cancelAtPeriodEnd
	}

	const renderCancelOrResumeSubscription = () => {
		if(checkShowResumeSubscription()) {
			return <Button className="btn-header btn-cancel-subscription btn hasResume" onClick={() => onCancelSubscription(false)}>{I18n.t('billingUsage.resumeSubscription')}</Button>
		} else if(billingUsage?.cancelAtPeriodEnd === false) {
			return <Button className="btn-header btn-cancel-subscription btn" onClick={() => setIsShowModalConfirmCancelSubscription(true)}>{I18n.t('billingUsage.cancelSubscription')}</Button>
		} else {
			return null
		}
	}
	const typeBilling = billingUsage.billingType === BILLING_PLAN_TYPE.annual ? I18n.t('billingUsage.annual') : I18n.t('billingUsage.monthly');
	return (
		<>
			{rendModalConfirmCancelSubscription()}
			<div className="update-subscription">
				<div className="update-subscription-header">
					<p>{I18n.t('billingUsage.subscriptionSummary')}</p>
					<span>{I18n.t('billingUsage.reviewAndUpdate')}</span>
				</div>
				<div className="cr-plan">
					<p>
						{I18n.t('billingUsage.plan')}
						<span>{billingUsage.planName} - {typeBilling} {I18n.t('billingUsage.subscriptionFee')}</span>
					</p>
					<p style={{ fontSize: '14px' }}>
						{
							`${formatCurrencyHasSymbol(billingUsage.fee || 0, billingUsage.currencyISO)}/${typeBilling}`
						}
					</p>
				</div>
				<div className="addOns">
					<p>{I18n.t('billingUsage.addOns')}</p>
					<div className="add-on-item">
						<p>
							{
								findAddOnsActive()?.map(addOn => {
									if (addOn?.pricingConfigs?.find(item => item.type === billingUsage.billingType)?.fee === 0) {
										return null
									}
									return (
										<p key={addOn._id}>
											<span className="add-on-name">{addOn.name}</span>
											<span className="add-on-price">
												{
													`${formatCurrencyHasSymbol(addOn?.pricingConfigs?.find(item => item.type === billingUsage.billingType)?.fee || 0, addOn.currencyISO)}/${typeBilling}`
												}
											</span>
										</p>
									)
								})
							}
						</p>
					</div>
				</div>
				<div className="total-price">
					<p>
						<span>{I18n.t('billingUsage.ongoingTotal')}</span>
						<span>{formatCurrencyHasSymbol(billingUsage.totalDue || 0, billingUsage.currencyISO)}</span>
					</p>
					{
						billingUsage?.cancelAtPeriodEnd === true ? (
							<span className="resume-subscription-text">{I18n.t('billingUsage.endOfSubscription')}: {formatDateBilling(billingUsage?.currentPeriodEnd)}</span>
						) : (
							<span>{I18n.t('billingUsage.nextBillingCycle')}: {formatDateBilling(billingUsage?.currentPeriodEnd)}</span>
						)
					}
				</div>
				<div className="text-center">
					{permissions.actions && renderCancelOrResumeSubscription()}
				</div>
			</div>
		</>
	)
}

export default SummarySubscription

